// extracted by mini-css-extract-plugin
export var container = "_8s-1";
export var cornerButtonContainer = "_8s-5";
export var disabled = "_8s-2";
export var fileContainer = "_8s-4";
export var hiddenInput = "_8s-3";
export var widthContainer = "_8s-0";